// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"31d2d5d5","184":"af978273","298":"66eb8161","312":"b90f177f","415":"90a32546","423":"11555855","453":"35429d6d","675":"6aade68a","760":"b93c5e75","803":"3d0902c6","813":"f41ab4b0","926":"314a0dc0","928":"74e8ec15"}[chunkId] + ".chunk.js";
};